import React from 'react';
import usePageMeta from '../hooks/usePageMeta';

export default function Product() {
    usePageMeta('CRO & eCommerce Development Services | Spinnennetz', 'Explore our CRO services: conversion landing pages, CRO sprints, monthly A/B testing, and Shopify or WooCommerce store development built to grow revenue.', '/products-solutions', {"@context":"https://schema.org","@type":"Service","name":"CRO & eCommerce Development Services","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <></>
        // <div className='cContainer'>products-solutions</div>
    );
}
